import React from 'react';
import PropTypes from 'prop-types';
import './AddOrSkipButton.scss';

const AddOrSkipButton = ({
    value = false,
    option1 = '',
    option2 = '',
    option1Action = () => {},
    option2Action = () => {},
    hideOption1 = false,
}) => {
    const shouldRenderSkip = !value && !hideOption1;

    return (
        <div className="add-or-skip-container">
            {value || shouldRenderSkip ? (
                <button
                    className={value ? 'add-members-btn' : 'skip-btn'}
                    onClick={value ? option2Action : option1Action}
                >
                    {value ? option2 : option1}
                </button>
            ) : (
                <div /> // spacer to avoid layout shift
            )}
        </div>
    );
};

AddOrSkipButton.propTypes = {
    value: PropTypes.bool,
    option1: PropTypes.string,
    option2: PropTypes.string,
    option1Action: PropTypes.func,
    option2Action: PropTypes.func,
    hideOption1: PropTypes.bool,
};

export default AddOrSkipButton;
